import { render } from "./add-sub_category.vue?vue&type=template&id=b7148374"
import script from "./add-sub_category.vue?vue&type=script&lang=js"
export * from "./add-sub_category.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__